var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { attr } from '@ember-data/model';
import { fragment, fragmentArray, array } from 'ember-data-model-fragments/attributes';
import { CatalogCategoryType as CatalogCategoryTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let CATEGORY_TYPE = /*#__PURE__*/function (CATEGORY_TYPE) {
  CATEGORY_TYPE["REGULAR_CATEGORY"] = "REGULAR_CATEGORY";
  CATEGORY_TYPE["MENU_CATEGORY"] = "MENU_CATEGORY";
  CATEGORY_TYPE["KITCHEN_CATEGORY"] = "KITCHEN_CATEGORY";
  return CATEGORY_TYPE;
}({});
export let NUMERIC_CATEGORY_TYPE = /*#__PURE__*/function (NUMERIC_CATEGORY_TYPE) {
  NUMERIC_CATEGORY_TYPE["REGULAR_CATEGORY"] = "1";
  NUMERIC_CATEGORY_TYPE["MENU_CATEGORY"] = "2";
  NUMERIC_CATEGORY_TYPE["KITCHEN_CATEGORY"] = "3";
  return NUMERIC_CATEGORY_TYPE;
}({});
let Data = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string', {
  protoEnum: CatalogCategoryTypeProto,
  defaultValue: CATEGORY_TYPE.REGULAR_CATEGORY
}), _dec6 = attr('boolean'), _dec7 = attr('boolean'), _dec8 = attr('number', {
  defaultValue: 0
}), _dec9 = attr('number', {
  defaultValue: 0
}), _dec10 = attr('string'), _dec11 = attr('boolean'), _dec12 = array(), _dec13 = fragment('connect/category/membership'), _dec14 = fragmentArray('connect/category/location-override'), _dec15 = fragment('connect/category/ecom-seo-data'), _dec16 = fragment('connect/category/open-graph-data'), (_class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "ordinal", _descriptor2, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor3, this);
    _initializerDefineProperty(this, "labelColor", _descriptor4, this);
    _initializerDefineProperty(this, "categoryType", _descriptor5, this);
    _initializerDefineProperty(this, "isTopLevel", _descriptor6, this);
    _initializerDefineProperty(this, "onlineVisibility", _descriptor7, this);
    _initializerDefineProperty(this, "itemCount", _descriptor8, this);
    _initializerDefineProperty(this, "categoryCount", _descriptor9, this);
    _initializerDefineProperty(this, "rootCategory", _descriptor10, this);
    _initializerDefineProperty(this, "migratedFromSquareOnline", _descriptor11, this);
    _initializerDefineProperty(this, "channels", _descriptor12, this);
    // array of site ids for now
    _initializerDefineProperty(this, "parentCategory", _descriptor13, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor14, this);
    _initializerDefineProperty(this, "ecomSeoData", _descriptor15, this);
    _initializerDefineProperty(this, "openGraphData", _descriptor16, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/category/data'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelColor", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "categoryType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isTopLevel", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onlineVisibility", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "itemCount", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "categoryCount", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "rootCategory", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "migratedFromSquareOnline", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "parentCategory", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoData", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "openGraphData", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Data as default };